module.exports = __webpack_public_path__ + "static/media/menu-wine-button.3c3e7ac7.jpg";